// extracted by css-extract-rspack-plugin
export default {"page":"uws3CA0MIA8WdvcJ","body":"I998s16jEgBv05XD","layout":"Bbtb2XZhqt4amSWV","main":"MymPuMGkvrkWkwOi","statusCard":"re2ksYva58IbfQmS"};